import { cases } from '@/mocks/cases';

export type CaseItem = (typeof cases)[number];
export type TimelineNode = CaseItem['timeline'][number];
export type Statement = CaseItem['statements'][number];

export const getCaseById = (id: string): CaseItem | undefined =>
  cases.find((item) => item.id === id);

export const getRelatedCases = (item: CaseItem): CaseItem[] =>
  item.related
    .map((rid) => cases.find((c) => c.id === rid))
    .filter((c): c is CaseItem => Boolean(c));